import { render, staticRenderFns } from "./EstimateDayworkRatesItem.vue?vue&type=template&id=023927ef&"
import script from "./EstimateDayworkRatesItem.vue?vue&type=script&lang=js&"
export * from "./EstimateDayworkRatesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports